import { render, staticRenderFns } from "./FinxIcon.vue?vue&type=template&id=44e308c5&scoped=true"
import script from "./FinxIcon.vue?vue&type=script&lang=js"
export * from "./FinxIcon.vue?vue&type=script&lang=js"
import style0 from "./FinxIcon.vue?vue&type=style&index=0&id=44e308c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e308c5",
  null
  
)

export default component.exports